import { gql } from '@apollo/client';



export const GET_RECENT_REGISTRATIONS = gql`
  query GetRecentRegistrations($limit: Int) {
    getRecentRegistrations(limit: $limit) {
      RegistrationId
      RegistrationNo
      CustomerName
      MobileNumber
      TotalAmount
      CreatedOn
      Tests {
        TestId
        TestName
      }
    }
  }
`;

export const QUICK_REGISTRATION = gql`
  mutation QuickRegistration($input: QuickRegistrationInput!) {
    quickRegistration(input: $input) {
      RegistrationId
      RegistrationNumber
      Customer {
        CustomerId
        CustomerName
        MobileNumber
        Age
        Gender
        EmailId
      }
      tests {
        RegistrationTestId
        TestId
        TestName
        TestAmount
        sampleId
        qrCode
      }
      TotalAmount
      PaidAmount
      BalanceAmount
      RegisteredOn
    }
  }
`;

export const GET_REGISTRATION = gql`
  query GetRegistration($id: Int!) {
    registration(id: $id) {
      RegistrationId
      RegistrationNumber
      Customer {
        CustomerId
        CustomerName
        MobileNumber
        Age
        Gender
      }
      tests {
        RegistrationTestId
        TestId
        TestName
        TestAmount
        ReportGenerated
      }
      TotalAmount
      PaidAmount
      BalanceAmount
      Full_Paid_Flag
      RegisteredOn
    }
  }
`;

export const GET_TODAY_REGISTRATION_COUNT = gql`
  query GetTodayRegistrationCount($branchId: Int) {
    getTodayRegistrationCount(branchId: $branchId)
  }
`;